import styled, { css } from 'styled-components';

const Action = styled.li`
  background-color: var(--neutral-bg-weak);
  list-style-type: none;
  display: flex;
  padding: 0 var(--spacing-5) 0 var(--spacing-3);
  &:first-of-type {
    border-top-left-radius: var(--border-radius-3);
    border-top-right-radius: var(--border-radius-3);
  }
  &:last-of-type {
    border-bottom-left-radius: var(--border-radius-3);
    border-bottom-right-radius: var(--border-radius-3);
  }
  &:hover,
  &:focus {
    background-color: var(--neutral-bg);
    cursor: pointer;
  }
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  width: max-content;
  &:hover {
    cursor: pointer;
  }
`;

const Element = styled.ul`
  border-radius: var(--border-radius-3);
  box-shadow: var(--elevation-1);
  margin-top: var(--spacing-3);
  position: absolute;
  z-index: 9999;
  width: max-content;
  outline: 0px;
  ${({ position }) => getPositions(position)}
`;

const WrapperElements = styled.div``;

const Item = styled.button`
  background-color: inherit;
  border-radius: inherit;
  border: none;
  padding: var(--spacing-3) var(--spacing-5);
  text-align: left;
  width: 100%;
  ${({ disabled }) => isDisabled(disabled)}
`;

const isDisabled = (disabled) => {
  return (
    disabled &&
    css`
      cursor: not-allowed;
    `
  );
};

const positions = {
  right: css``,
  left: css`
    right: 120%;
  `,
};

const getPositions = (position) => {
  return position && positions[position];
};

export { Action, Item, Wrapper, WrapperElements, Element };
